import React, { useEffect, useState } from 'react';
import { motion, useMotionValue, useTransform } from 'framer-motion';
import { default as __ } from '../../utils';
import { colors } from '../../styles';

const config = {
  min: 10,
  max: 100,
  threshold: 20,
  shadeB: colors.accent,
  shadeC: colors.highlight,
};

const Switch = ({ isOff = false, isOn, cb }) => {
  let [isDragging, setDragging] = useState(false);

  let xInput = [config.min, config.max];
  let origin = useMotionValue(isOn ? config.max : config.threshold);
  let mark = useTransform(origin, xInput, [config.shadeB, config.shadeC]);

  let position = delta => {
    origin.set(__.clamp(origin.get() + delta.x, config.min, config.max));
  };

  let onEnd = () => {
    let point = origin.get();
    if (point > config.max / 2) {
      origin.set(config.max);
      cb(true);
    } else {
      origin.set(config.min);
      cb(false);
    }
  };

  return (
    <div
      style={{
        padding: '20px 0',
        position: 'relative',
        width: `${config.max}px`,
      }}
    >
      <motion.div
        className="border-radius"
        style={{
          backgroundColor: isOff ? colors.highlight : colors.accent_alpha,
          height: '44px',
          // rotate:'-45deg'
        }}
      >
        <motion.div
          className="border-radius"
          whileTap={{ scale: 1.1 }}
          drag="x"
          dragConstraints={{ left: 5, right: 0 }}
          dragElastic={0}
          dragTransition={{
            bounceStiffness: 300,
            timeConstant: 200,
            power: 0.2,
            bounceDamping: 10,
          }}
          style={{
            translateX: -origin,
            width: origin,
            height: '44px',
            backgroundColor: mark,
            // rotate:'-45deg'
          }}
          onDrag={(e, { delta }) => {
            if (isDragging) {
              position(delta);
            }
            return !isDragging;
          }}
          onDragStart={() => setDragging(true)}
          onDragEnd={() => __.callAll(setDragging(false), onEnd())}
        />
      </motion.div>
    </div>
  );
};

export default Switch;
